module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_4.1bf1a37e.png";